import React from 'react'

import inviteNonEligibleEmployee from 'core/application/adminDashboard/managePeople/invitations/inviteNonEligibleEmployee'
import { EmployeeResponse } from 'core/application/companies/getEmployees'

import Modal from 'common/components/feedback/Modal'
import notification from 'common/components/feedback/Notification'

//
import { commandRequest } from 'common/RequestUtils'

export const inviteNonEligibleEmployees = (record: EmployeeResponse, eligible: boolean, translate: any) => {
  const sendOrResendTitle = record.canBeReInvited
    ? `Ready to reinvite ${record.firstName} ${record.lastName}?`
    : `Ready to send a welcome email to ${record.firstName} ${record.lastName}?`

  const sentOrResendContent = record.canBeReInvited ? (
    <div>{translate('admin-dashboard.manage-people.perks-reinvite-alert-desc')}</div>
  ) : (
    <div>{translate('admin-dashboard.manage-people.perks-invite-alert-desc')}</div>
  )

  return new Promise<void>((resolve) => {
    Modal.confirm({
      title: sendOrResendTitle,
      onOk: async () => {
        await handleInvitenNonEligibleEmployees(record, translate)
        resolve()
      },
      okType: 'primary',
      okText: 'Send',
      content: sentOrResendContent,
    })
  })
}

const handleInvitenNonEligibleEmployees = async (record: EmployeeResponse, translate: any) => {
  const result = await commandRequest(() => inviteNonEligibleEmployee(record))
  if (!result.errors) {
    notification.open({
      message: translate('admin-dashboard.manage-people.invite-success-header'),
      description: translate('admin-dashboard.manage-people.invite-success-desc'),
      type: 'success',
    })
  } else {
    notification.open({
      message: result.errors[0],
      type: 'error',
    })
  }
}
